$(function() {  				
    $('.changeModal').on('click', function () {            					
        $('.modal-content').toggleClass('view-change');
    });
});


$(function(){
    $(window).scroll(function(){
        if ($(this).scrollTop() > 150) {
            $('.siteHeader').addClass('hide-header2');
        } else {
            $('.siteHeader').removeClass('hide-header2');
        }
    });
}); 



























    







